import { Component, ViewChild } from '@angular/core';
import { ANGULAR_MODULES, OperationsComponent, SYNCFUSION_MODULES, TopBarComponent } from 'src/app/Shared/shared-imports';
import { WordReplacePipe } from 'src/app/Shared/word-replace.pipe';
import { PosSoldItemSearchservice } from '../../../services/PosSoldItemSearch.service';
import { VendorService } from '../../../services/Vendor.service';
import { UserService } from '../../../services/User.service';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { VendorSearchComponent } from 'src/app/Shared/vendor-search/vendor-search.component';
import { customCurrencyPipe } from 'src/app/Shared/customCurrency.pipe';
import { EActionTypes, EToaster, EUserSecurityFunctionID, ESaleType } from "src/app/Shared/enum";
import { IUserPermissionHandler } from "src/app/Shared/model/CommonModel";
import { UserPermissionHandlerDirective } from "src/app/Shared/userPermissionHandler.directive";
import { LoaderComponent } from 'src/app/Shared/loader/loader.component';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs';
import Swal from 'sweetalert2';
declare var $: any;
declare var bootstrap: any;

@Component({
  selector: 'app-ops-sold-items-search',
  imports: [SYNCFUSION_MODULES, ANGULAR_MODULES, OperationsComponent, TopBarComponent, WordReplacePipe, VendorSearchComponent, UserPermissionHandlerDirective, LoaderComponent],
  standalone: true,
  templateUrl: './ops-sold-items-search.html',
  styleUrl: './ops-sold-items-search.scss'
})
export class OpsSoldItemsSearch {
  isCollapsed = true;
  @ViewChild('gridPosSoldItemSearch', { static: false }) public gridPosSoldItemSearch: GridComponent;
  viewPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.SoldItemSearch, Action: EActionTypes.VIEW };

  constructor(private fb: FormBuilder, private soldItemService: PosSoldItemSearchservice,
    private toastr: ToastrService, private vendorService: VendorService, private userService: UserService,
    private router: Router, private customCurrency: customCurrencyPipe) {

    this.soldItemSearchForm = this.fb.group({
      fromDate: [new Date()],
      toDate: [new Date()],
      terminal: ['ALL'],
      user: ['ALL'],
      vendorId: '',
      vendorName: [''],
      itemSearch: [''],
      priceSearch: [{ value: '', disabled: true }],
      searchBy: ['item'], // item | stock | price
      vendorFilter: ['false'],
      soldItemVendorId: [''],
      soldItemVendorName: [{ value: '', disabled: true }],
      soldItemVendorAlphaNumericId: [{ value: '', disabled: true }],
      searchWholeWordOnly: [false],
      showAllSoldItems: [false],
      rateUnit: [this.customCurrency.transform('0.00'), [Validators.required, Validators.min(0)]],
    }, {
      validators: this.dateRangeValidator
    });

    this.subscriptions.push(
      this.soldItemSearchForm.get('vendorFilter')?.valueChanges.subscribe((value) => {
        const idControl = this.soldItemSearchForm.get('soldItemVendorAlphaNumericId');
        const nameControl = this.soldItemSearchForm.get('soldItemVendorName');

        const isRequested = value === 'true';

        if (isRequested) {
          idControl?.enable({ emitEvent: false });
          nameControl?.enable({ emitEvent: false });
        } else {
          idControl?.disable({ emitEvent: false });
          nameControl?.disable({ emitEvent: false });
          this.soldItemSearchForm.patchValue({
            soldItemVendorAlphaNumericId: '',
            soldItemVendorId: '',
            soldItemVendorName: ''
          }, { emitEvent: false });

          this.getSoldItems();
        }
      })!
    );

    this.subscriptions.push(
      this.soldItemSearchForm.get('searchBy')?.valueChanges.subscribe((value) => {
        const soldItemNameControl = this.soldItemSearchForm.get('itemSearch');
        const priceControl = this.soldItemSearchForm.get('priceSearch'); // assuming you have this form control

        if (!soldItemNameControl || !priceControl) return;

        if (value === 'price') {
          priceControl.enable();
          soldItemNameControl.disable();
          soldItemNameControl.setValue('');
        } else {
          soldItemNameControl.enable();
          priceControl.disable();
          priceControl.setValue('');
        }
      })
    );
  }

  VendorFilterOption = {
    All: true,
    Current: false,
    Inactive: false,
    PageModel: {
      pageCount: 1,
      pageSize: 20
    }
  };

  soldItemSearchForm!: FormGroup;
  soldItems: any[] = [];
  loaderIcon: Promise<boolean> = Promise.resolve(false);
  userList: any[] = [];
  terminals: any[] = [];
  private subscriptions: Subscription[] = [];

  pageNumber = 0;
  pageSize = 100;
  totalRecords = 0;
  private hasMoreRecords = true;
  private loading = false;
  private scrollAttached = false;
  private boundScroll = this.onGridScroll.bind(this);
  private soldItemsSubscription?: Subscription;
  private usersTerminalsKey = '';
  private usersTerminalsSub?: Subscription;

  ngOnInit(): void {
    this.soldItemSearchForm.valueChanges
      .pipe(
        debounceTime(100),
        distinctUntilChanged()
      )
      .subscribe(() => {

        if (!this.soldItemSearchForm.valid) {
          return;
        }

        // Don't search while user is typing Vendor ID
        if (
          this.soldItemSearchForm.get('vendorFilter')?.value === 'true' &&
          !this.soldItemSearchForm.get('soldItemVendorId')?.value
        ) {
          return;
        }

        this.getSoldItems();
      });

    this.soldItemSearchForm.get('soldItemVendorAlphaNumericId')?.valueChanges
      .pipe(
        debounceTime(800),
        distinctUntilChanged()
      )
      .subscribe(() => {
        this.getVendorById();
      });

    this.getSoldItems();
  }

  loadUsersAndTerminals(): void {
    const { fromDate, toDate } = this.soldItemSearchForm.value;
    if (!fromDate || !toDate) return;

    const from = this.formatDateMMDDYYYY(fromDate);
    const to = this.formatDateMMDDYYYY(toDate);
    const key = `${from}|${to}`;

    // dropdowns depend only on the date range, so skip if it hasn't changed
    if (key === this.usersTerminalsKey) return;
    this.usersTerminalsKey = key;

    this.usersTerminalsSub?.unsubscribe();
    this.usersTerminalsSub = this.soldItemService
      .getDistinctUsersAndTerminals(from, to)
      .subscribe({
        next: (res) => {
          this.userList = res.Users;
          this.terminals = res.Terminals;
        },
        error: (err) => {
          this.usersTerminalsKey = '';   // allow a retry on the next search
          console.error('Error loading user/terminal list:', err);
        }
      });
  }

  getSoldItems(reset: boolean = true): void {
    if (this.soldItemSearchForm.invalid) {
      this.showWarning('From Date cannot be greater than To Date');
      return;
    }

    if (reset) {
      // cancel any in-flight request so stale results can't be appended
      this.soldItemsSubscription?.unsubscribe();
      this.soldItemsSubscription = undefined;
      this.loading = false;            

      this.pageNumber = 0;
      this.totalRecords = 0;
      this.hasMoreRecords = true;
      this.soldItems = [];
    } else if (this.loading || !this.hasMoreRecords) {
      return;
    }

    const form = this.soldItemSearchForm.value;
    const fromDate = this.formatDateMMDDYYYY(form.fromDate);
    const toDate = this.formatDateMMDDYYYY(form.toDate);

    this.loading = true;
    if (reset) {
      this.loaderIcon = Promise.resolve(true);
    }

    this.soldItemsSubscription = this.soldItemService
      .getSoldItemList(
        fromDate,
        toDate,
        {
          vendorId: form.soldItemVendorId,
          itemSearch: form.itemSearch,
          priceSearch: form.priceSearch,
          searchByItemName: form.searchBy,
          searchWholeWordOnly: form.searchWholeWordOnly,
          showAllSoldItems: form.showAllSoldItems,
          terminal: form.terminal,
          user: form.user
        },
        this.pageNumber,
        this.pageSize
      )
      .subscribe({
        next: (res: any) => {
          const result = res?.Result ?? [];

          // the API returns the total only for the first page
          if (reset) {
            this.totalRecords = Number(res?.Count ?? 0);
          }

          const mappedItems = result.map((el: any) => ({
            invoiceNo: el.InvoiceNumber ?? '',
            invoiceDate: el.InvoiceDate ? new Date(el.InvoiceDate) : null,
            vendorId: el.MarketVendorId ?? '',
            saleType: ESaleType[el.SaleType] ?? '',
            stockId: el.StockId ?? '',
            itemDescription: el.ItemDescription ?? '',
            rateUnit: this.customCurrency.transform(el.Rate ?? 0),
            qty: el.Quantity ?? 0,
            terminal: el.Terminal ?? '',
            user: el.User ?? ''
          }));

          this.soldItems = reset ? mappedItems : [...this.soldItems, ...mappedItems];

          this.pageNumber += result.length;
          this.hasMoreRecords = result.length > 0 && this.pageNumber < this.totalRecords;

          this.loading = false;
          this.loaderIcon = Promise.resolve(false);
          this.attachGridScroll();
        },
        error: (err) => {
          console.error('Error fetching sold items:', err);
          this.loading = false;
          this.loaderIcon = Promise.resolve(false);
          this.toastr.error('Failed to fetch sold items.', 'Error');
        }
      });

    // users/terminals depend only on the date range, so load them on a new search only
    if (reset) {
      this.loadUsersAndTerminals();
    }
  }

  private attachGridScroll(): void {
    if (this.scrollAttached) {
      return;
    }
    const content = this.gridPosSoldItemSearch?.element?.querySelector('.e-content');
    if (!content) {
      return;
    }
    this.scrollAttached = true;
    content.addEventListener('scroll', this.boundScroll);
  }

  onGridDataBound(): void {
    this.attachGridScroll();
  }

  onGridScroll(event: any): void {
    if (this.loading) {
      return;
    }
    if (!this.hasMoreRecords) {
      return;
    }
    const element = event.target;
    const remaining = element.scrollHeight - element.scrollTop - element.clientHeight;

    // Start loading the next page when approximately 20px from the bottom.
    if (remaining > 20) {
      return;
    }
    this.getSoldItems(false);
  }

  private showWarning(message: string) {
    Swal.fire({
      title: $localize`Warning`,
      text: message,
      icon: "warning",
      confirmButtonText: $localize`Ok`,
    });
  }

  openVendorModal() {
    document.querySelectorAll('.modal-backdrop').forEach(e => e.remove());
    const vendorModal = new bootstrap.Modal(
      document.getElementById('vendorSearchModal')!,
      {
        backdrop: 'static',
        keyboard: false,
        focus: true
      }
    );
    vendorModal.show();
  }

  getVendorById(): void {
    const vendorId = this.soldItemSearchForm.get('soldItemVendorAlphaNumericId')?.value;
    if (!vendorId) {
      this.soldItemSearchForm.patchValue({ soldItemVendorName: '', soldItemVendorId: '' });
      return;
    }

    this.subscriptions.push(
      this.vendorService.getVendorInfoByMarketVendorId(vendorId)
        .pipe(take(1))
        .subscribe((res) => {
          if (res?.VendorId) {
            this.soldItemSearchForm.patchValue({
              soldItemVendorId: res.VendorId,
              soldItemVendorName: res.VendorName,
            }, { emitEvent: false });
            this.getSoldItems();
          }
          else {
            this.soldItemSearchForm.patchValue({
              soldItemVendorId: '',
              soldItemVendorName: '',
            }, { emitEvent: false });
            this.showWarning($localize`Vendor ID does not exist.`);
            this.getSoldItems();
          }
        })
    );
  }

  onVendorSelected(vendor: any) {
    this.soldItemSearchForm.patchValue({
      soldItemVendorAlphaNumericId: vendor.marketVendorId,
      soldItemVendorId: vendor.vendorId,
      soldItemVendorName: vendor.vendorName
    });

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }

  dateRangeValidator = (form: FormGroup) => {
    const from = form.get('fromDate')?.value;
    const to = form.get('toDate')?.value;

    if (from && to && from > to) {
      return { invalidDateRange: true };
    }
    return null;
  };

  onFromDateChange(event: any) {
    const fromDate = event.value;
    const toDate = this.soldItemSearchForm.get('toDate')?.value;

    if (fromDate && toDate && fromDate > toDate) {
      const today = new Date();

      this.soldItemSearchForm.patchValue({
        fromDate: today,
        toDate: today
      }, { emitEvent: false });

      this.showWarning('Invalid date range. Reset to today.');
    }
  }

  onToDateChange(event: any) {
    const toDate = event.value;
    const fromDate = this.soldItemSearchForm.get('fromDate')?.value;

    if (fromDate && toDate && toDate < fromDate) {
      const today = new Date();

      this.soldItemSearchForm.patchValue({
        fromDate: today,
        toDate: today
      }, { emitEvent: false });

      this.showWarning('Invalid date range. Reset to today.');
    }
  }

  formatDateMMDDYYYY(date: Date): string {
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  }

  onClose(): void {
    this.isCollapsed = true;
    this.router.navigate(['/dashboard']);
  }

  handleToggle(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  ngOnDestroy(): void {
    const content = this.gridPosSoldItemSearch?.element?.querySelector('.e-content');

    if (content) {
      content.removeEventListener('scroll', this.boundScroll);
    }

    if (this.soldItemsSubscription) {
      this.soldItemsSubscription.unsubscribe();
    }

    this.usersTerminalsSub?.unsubscribe();

    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
}
